import { get, put, post, del } from '@/request/http.js';


const api = {
  // 登录
  login: (params) => post('/api/login', params),
}

export default api;